import { useState } from 'react';
import clsx from 'clsx';
import { SubscribersList } from './components/SubscribersList.jsx';
import { SubscriptionsReport } from './components/SubscriptionsReport.jsx';
import { PlansList } from './components/plans/PlansList.jsx';

const TABS = [
  { key: 'subscribers', label: 'المشتركون' },
  { key: 'plans', label: 'الباقات الشهرية' },
  { key: 'report', label: 'التقرير' }
];

export function SubscriptionsScreen() {
  const [tab, setTab] = useState('subscribers');

  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div>
          <h2 className="text-xl font-extrabold tracking-tight m-0">الاشتراكات الشهرية</h2>
          <div className="text-ink-3 text-xs mt-0.5">
            دخول غير محدود للطفل خلال فترة الاشتراك — مستقل عن التسعير بالساعة والباقات الزمنية
          </div>
        </div>
        <div className="inline-flex items-center gap-1 p-1 bg-white border border-line rounded-[10px] shadow-card">
          {TABS.map((t) => (
            <button
              key={t.key}
              type="button"
              onClick={() => setTab(t.key)}
              className={clsx(
                'px-3.5 py-1.5 rounded-[8px] text-[12.5px] font-semibold transition-colors',
                tab === t.key ? 'bg-orange text-white shadow-orange-glow' : 'text-ink-2 hover:bg-paper-2'
              )}
            >
              {t.label}
            </button>
          ))}
        </div>
      </div>

      {tab === 'subscribers' ? <SubscribersList /> : null}
      {tab === 'plans' ? <PlansList /> : null}
      {tab === 'report' ? <SubscriptionsReport /> : null}
    </div>
  );
}
